<h2 mat-dialog-title>Create Activity</h2>
<mat-dialog-content>
  <mat-form-field>
    <mat-label>Activity Type</mat-label>
    <mat-select [(ngModel)]="selectedActivity" class="select-field inverted" panelClass="underline-select-panel">
      @for (option of activityOptions; track option) {
      <mat-option [value]="option.value">
        {{ option.label }}
      </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field class="full-width">
    <mat-label>UTC Date and Time</mat-label>
    <input matInput type="datetime-local" [(ngModel)]="activityDateTime" [min]="minDateTime" />
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="onCreate()" [disabled]="!selectedActivity || !activityDateTime">
    Create
  </button>
</mat-dialog-actions>
